import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { IDynamicFormModel } from '@adex/shared/modules/dynamic-form/models/dynamic-form.model'
import { Observable, ReplaySubject } from 'rxjs'
import { IEmailDto } from '@adex/shared/models/dto/email.dto'
import { IBaseForm } from '../../models/base-form'
import { map } from 'rxjs/operators'


@Component({
  selector: 'adex-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [ './forgot-password.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent<T = IEmailDto> implements IBaseForm<T> {

  @Input() public model: IDynamicFormModel

  @Output() public submitForm: EventEmitter<T> = new EventEmitter()

  public validForm$: ReplaySubject<boolean> = new ReplaySubject(1)
  public disabledButton$: Observable<boolean> = this.validForm$.pipe(map(v => !v))
  private formValue: T

  public onChangeForm(formValue: T): void {
    this.formValue = formValue
  }

  public onSubmit(): void {
    if (!this.formValue) return
    this.submitForm.emit(this.formValue)
  }

}
